import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { useLayoutGet, useLayoutUpdate } from '../api/layouts'
import { ObjectLayoutsForm } from './object-layouts-form'

export function ObjectLayoutsEdit({ kind }: { kind?: string }) {
	const { object = kind, id = '' } = useParams<{ object: string; id: string }>()
	if (!object) throw new Error('Invalid invocation')
	const { data, isSuccess, dataUpdatedAt } = useLayoutGet(id)
	const { mutate, isPending } = useLayoutUpdate(id)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()

		const formData = new FormData(form)
		const updateData = {
			type: formData.get('type') as string,
			name: formData.get('name') as string,
			configuration: JSON.parse((formData.get('configuration') as string) || '{}'),
		}

		mutate(updateData)
	}

	if (!isSuccess) return null

	return (
		<ObjectLayoutsForm
			object={object}
			key={dataUpdatedAt}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
		/>
	)
}
